export default {
      id: "favourite-usage",
      viewBox: "0 0 26 24",
      url: "/" + "sprite.svg#favourite",
      toString: function () {
        return this.url;
      }
    }